import React from 'react'
import SelectField, { SelectFieldProps } from './SelectField'
import Loader from '../loader/Loader'
import { useMarketsQuery } from '../../__generated__/graphql'
import getMarketCode from '../../utils/getMarketCode'

const MarketSelectField: React.FC<SelectFieldProps> = ({ name, label, required, variant }) => {
  const { data: marketsFromDB, loading: loadingMarkets } = useMarketsQuery()

  if (loadingMarkets) return <Loader />
  return (
    <SelectField
      name={name}
      label={label}
      withNone={false}
      required={required}
      variant={variant}
      options={marketsFromDB?.searchMarkets?.map((market) => ({
        value: parseInt(market.id),
        label: getMarketCode(market),
      }))}
    />
  )
}

export default MarketSelectField
